import src from "IMAGE";
export default { src, width: 196, height: 195, blurWidth: 0, blurHeight: 0};
